import { Box, Typography, useTheme } from "@mui/material";
import { useIntl } from "../../contexts/IntlContext";
import { PasswordRule } from "../../utils/passwordValidator";

interface PasswordCriteriaProps {
  passwordRules: PasswordRule[];
}

export function PasswordCriteria({ passwordRules }: PasswordCriteriaProps) {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {intl.formatMessage({ id: 'resetPassword.criteriaTitle' })}
      </Typography>
      {passwordRules.map((rule) => (
        <Box
          key={rule.name}
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 0.5,
            color: rule.error ? theme.palette.error.main : theme.palette.success.main,
          }}
        >
          <Typography variant="body2" sx={{ mr: 1 }}>
            {rule.error ? "✗" : "✓"}
          </Typography>
          <Typography variant="body2">
            {intl.formatMessage({ id: 'resetPassword.' + rule.name }, { min: rule.min })}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}